"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const src_1 = require("@rover/ts-bootstrap/dist/src");
const qs_1 = require("qs");
const React = require("react");
const ReactDOM = require("react-dom");
const react_redux_1 = require("react-redux");
const react_router_1 = require("react-router");
const react_router_dom_1 = require("react-router-dom");
const actions_1 = require("../../actions");
const reducers_1 = require("../../reducers");
const Report_1 = require("../Report");
const Settings_1 = require("../Settings");
const ResponsiveContainer_1 = require("../utils/ResponsiveContainer");
const OverviewContainer_1 = require("../wizards/overview/OverviewContainer");
const CampaignsList_1 = require("./CampaignsList");
const NavBar_1 = require("./NavBar");
const ToolBar_1 = require("./ToolBar");
class ListPage extends React.PureComponent {
    constructor(props) {
        super(props);
        this.createNewCampaign = this.createNewCampaign.bind(this);
        this.pushToModal = this.pushToModal.bind(this);
    }
    componentWillMount() {
        const { fetchCampaign, fetchCampaigns, fetchExperiences, fetchSegments, fetchTestDevices, fetchEventSchemas, getCampaignExists, } = this.props;
        const { campaignId } = this.getQueryParams();
        if (!getCampaignExists(campaignId)) {
            const id = parseInt(campaignId, 10);
            if (!isNaN(id)) {
                fetchCampaign(id);
            }
        }
        fetchCampaigns(false, 50, '');
        fetchExperiences();
        fetchSegments();
        fetchTestDevices();
        fetchEventSchemas();
    }
    componentDidUpdate(nextProps) {
        const { fetchCampaigns, location, fetchCampaign, getCampaignExists } = this.props;
        const nextSearch = nextProps.location.search;
        const { campaignId } = this.getQueryParams();
        const searchChange = location.search !== nextSearch;
        if (searchChange && campaignId && !getCampaignExists(campaignId)) {
            fetchCampaign(parseInt(campaignId, 10));
        }
        if (searchChange && !campaignId) {
            fetchCampaigns(true, 50);
        }
    }
    createNewCampaign(name, trigger) {
        this.props.createCampaign(name, trigger);
    }
    getQueryParams() {
        const { location } = this.props;
        return qs_1.parse(location.search.substring(1));
    }
    setListStatus(nextStatus) {
        const { history } = this.props;
        const newQuery = qs_1.stringify(Object.assign(Object.assign({}, this.getQueryParams()), { campaignStatus: nextStatus }));
        history.replace(`/campaigns/?${newQuery}`);
    }
    setListType(nextType) {
        const { closeCampaignTypeSelector, history } = this.props;
        const newQuery = qs_1.stringify(Object.assign(Object.assign({}, this.getQueryParams()), { campaignType: nextType }));
        closeCampaignTypeSelector();
        history.replace(`/campaigns/?${newQuery}`);
    }
    setKeyword(keyword) {
        const { history } = this.props;
        const newQuery = qs_1.stringify(Object.assign(Object.assign({}, this.getQueryParams()), { keyword: keyword !== '' ? keyword : undefined }));
        history.replace(`/campaigns/?${newQuery}`);
    }
    setPageNumber(direction) {
        const { history } = this.props;
        const params = this.getQueryParams();
        const { pageNumber = '0' } = params;
        let nextPageNumber = parseInt(pageNumber, 10);
        if (direction === 'forward') {
            nextPageNumber += 1;
        }
        if (direction === 'backward' && nextPageNumber > 0) {
            nextPageNumber -= 1;
        }
        const newQuery = qs_1.stringify(Object.assign(Object.assign({}, params), { pageNumber: nextPageNumber }));
        history.replace(`/campaigns/?${newQuery}`);
    }
    pushToModal(campaignId, route) {
        const { handleOpenOverviewModalDisplay, history } = this.props;
        const params = this.getQueryParams();
        const newQuery = qs_1.stringify(Object.assign(Object.assign({}, params), { campaignId }));
        history.replace(`/campaigns/${route}/?${newQuery}`);
        handleOpenOverviewModalDisplay();
    }
    render() {
        const { Fragment } = React;
        const { getCampaignExists, device, location, fetchCampaigns } = this.props;
        const { campaignStatus = 'all', campaignType = 'all', keyword, campaignId } = this.getQueryParams();
        const shouldShowWizard = location.pathname === '/campaigns/wizard/' && getCampaignExists(campaignId);
        const shouldShowReport = location.pathname === '/campaigns/report/' && getCampaignExists(campaignId);
        const shouldShowSettings = location.pathname === '/campaigns/settings/' && getCampaignExists(campaignId);
        return (React.createElement(react_router_dom_1.Route, { path: location.pathname, render: () => (React.createElement(Fragment, null,
                shouldShowWizard && React.createElement(OverviewContainer_1.default, { device: device }),
                shouldShowSettings && React.createElement(Settings_1.default, { device: device }),
                shouldShowReport && React.createElement(Report_1.default, { device: device }),
                React.createElement("div", { style: {
                        width: '100vw',
                        height: '100%',
                        display: 'flex',
                        flexDirection: 'column',
                        position: 'absolute',
                        top: 0,
                        zIndex: 1,
                    } },
                    React.createElement(NavBar_1.default, { media: device, onCreate: (name, trigger) => this.createNewCampaign(name, trigger), style: { flex: '0 0 auto' }, setKeyword: (keyword) => this.setKeyword(keyword) }),
                    React.createElement(CampaignsList_1.default, { media: device, pushToModal: this.pushToModal, style: { flex: '1 1 auto' }, campaignType: campaignType, campaignStatus: campaignStatus, fetchCampaigns: (first, after) => fetchCampaigns(false, first, after) }),
                    React.createElement(ToolBar_1.default, { media: device, keyword: keyword || '', campaignStatus: campaignStatus, campaignType: campaignType, onCreate: (name, trigger) => this.createNewCampaign(name, trigger) })),
                this.props.isError.error &&
                    ReactDOM.createPortal(React.createElement("div", { style: {
                            zIndex: 20,
                            justifyContent: 'center',
                            position: 'absolute',
                            width: 300,
                            top: 5,
                            left: 'calc(50% - 150px)',
                            alignItems: 'center',
                        } },
                        React.createElement(src_1.Alert, { message: "Oops! Something went wrong.", type: "error" })), document.getElementById('root')))) }));
    }
}
const debounce = (func, delay) => {
    let inDebounce;
    return function () {
        const context = this;
        const args = arguments;
        clearTimeout(inDebounce);
        inDebounce = window.setTimeout(() => func.apply(context, args), delay);
    };
};
const mapDispatchToProps = (dispatch, ownProps) => {
    const { device } = ownProps;
    const { campaignStatus, campaignType, keyword } = qs_1.parse(location.search.substring(1));
    let nextStatus;
    switch (campaignStatus) {
        case 'drafts':
            nextStatus = 'DRAFT';
            break;
        case 'published':
            nextStatus = 'PUBLISHED';
            break;
        case 'all':
        default:
            nextStatus = null;
            break;
    }
    let nextTypes = [];
    switch (campaignType) {
        case 'scheduled':
            nextTypes = ['SCHEDULED'];
            break;
        case 'automated':
            nextTypes = ['AUTOMATED'];
            break;
        case 'api':
            nextTypes = ['API'];
            break;
        case 'all':
        default:
            nextTypes = ['SCHEDULED', 'AUTOMATED', 'API'];
            break;
    }
    return {
        closeCampaignTypeSelector: () => {
            if (device === 'Mobile') {
                dispatch({ type: 'START_CLOSING_CAMPAIGN_TYPE_SELECTOR' });
                setTimeout(() => dispatch(actions_1.closeCampaignTypeSelector()), 295);
            }
            else {
                dispatch(actions_1.closeCampaignTypeSelector());
            }
        },
        createCampaign: (name, trigger) => {
            dispatch(actions_1.createCampaign(name, trigger)).then((id) => {
                let path;
                if (id === undefined) {
                    path = ownProps.location.pathname;
                }
                else {
                    if (!ownProps.location.search.includes('?')) {
                        path = `${ownProps.location.pathname}wizard/${ownProps.location.search}?campaignId=${id}`;
                    }
                    else {
                        path = `${ownProps.location.pathname}wizard/${ownProps.location.search}&campaignId=${id}`;
                    }
                }
                ownProps.history.push(path);
                dispatch(actions_1.handleOpenOverviewModalDisplay());
            });
        },
        fetchCampaigns: (searchChange, first, after) => {
            dispatch(debounce(actions_1.fetchCampaigns(searchChange, nextStatus, keyword, first, after, nextTypes), 400));
        },
        fetchCampaign: (campaignId) => {
            dispatch(actions_1.fetchCampaign(campaignId)).then(() => undefined, () => {
                ownProps.history.replace('/campaigns/');
            });
        },
        fetchEventSchemas: () => dispatch(actions_1.fetchEventSchemas()),
        fetchExperiences: () => dispatch(actions_1.fetchExperiences()),
        fetchSegments: () => dispatch(actions_1.fetchSegments()),
        fetchTestDevices: () => dispatch(actions_1.fetchTestDevices()),
        handleOpenOverviewModalDisplay: () => dispatch(actions_1.handleOpenOverviewModalDisplay()),
    };
};
const mapStateToProps = (state) => ({
    campaigns: state.campaignConnection.campaigns,
    getCampaignExists: (id) => reducers_1.getCampaignExists(state, id),
    isError: reducers_1.getIsError(state),
});
exports.default = react_router_1.withRouter(react_redux_1.connect(mapStateToProps, mapDispatchToProps)((props) => ResponsiveContainer_1.default(props)(ListPage)));
